(() => {
  const labels = { 'EFFETTI': 'Benefici', 'PER CHI': 'A chi è indicato', "MODO D'USO": 'Come si usa', 'MODALITÀ D’USO': 'Come si usa', 'INGREDIENTI': 'Ingredienti' };
  function enhance() {
    document.querySelectorAll('.of-catalog-nav details').forEach(d => { if(d.dataset.bound)return;d.dataset.bound='1';d.addEventListener('toggle',()=>{if(d.open)d.parentElement.querySelectorAll('details').forEach(other=>{if(other!==d)other.open=false})}) });
    const area = document.querySelector('.template-product .product__description__content');
    if (!area || area.dataset.organized) return;
    const root = area.querySelector('.toggle-ellipsis__content') || area.querySelector('[data-content]') || area;
    const headings = [...root.querySelectorAll('p,h2,h3,h4,h5,h6')].filter(el => labels[el.textContent.trim().toUpperCase()]);
    if (!headings.length) return;
    const parent = headings[0].parentElement;
    if (!headings.every(h=>h.parentElement===parent)) return;
    area.dataset.organized='1';
    let body=null;
    [...parent.childNodes].forEach(node=>{
      if(headings.includes(node)){
        const detail=document.createElement('details');detail.className='of-product-detail';
        const summary=document.createElement('summary');summary.textContent=labels[node.textContent.trim().toUpperCase()];
        body=document.createElement('div');detail.append(summary,body);parent.insertBefore(detail,node);node.remove();
      } else if(body) body.append(node);
    });
    parent.querySelectorAll('p').forEach(p=>{if(!p.textContent.trim()&&!p.querySelector('img,a'))p.remove()});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance);else enhance();
  document.addEventListener('shopify:section:load',enhance);
})();
